import { Typography } from "@mui/material";

export const noThreadFound = (
  <Typography
    component="div"
    sx={{ mt: 2, mx: "auto", textAlign: "center" }}
    variant="caption"
    color="textSecondary"
  >
    No email thread could be found. Contact hello@onbento.com for assistance if
    this is not expected.
  </Typography>
);
